module.exports = __webpack_public_path__ + "36bef8c97d0ed97d72a9eb0a19e16c2f.svg";